import React from 'react';
import { motion } from 'framer-motion';
import { FiArrowRight } from 'react-icons/fi';

const Hero = () => {
  return (
    <section id="home" className="relative min-h-screen flex items-center pt-20 overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img 
          src="/assets/images/hero.jpg" 
          alt="Logistics Port" 
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-brand-black/90 via-brand-black/70 to-transparent"></div>
      </div>

      <div className="container mx-auto px-4 md:px-8 z-10">
        <div className="max-w-3xl">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <span className="inline-block py-1 px-3 rounded-full bg-brand-black/20 text-brand-red font-semibold text-sm mb-6 border border-brand-red/30 backdrop-blur-sm">
              Tanjung Priok Logistik
            </span>
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-6">
              Solusi Logistik <br/>
              <span className="text-brand-red">Terintegrasi</span>, Menjangkau Dunia.
            </h1>
            <p className="text-gray-300 text-lg md:text-xl mb-10 leading-relaxed max-w-2xl">
              Dari pengiriman dalam kota hingga jaringan internasional, kami memastikan setiap paket dan kargo Anda sampai di tujuan dengan aman, tepat waktu, dan efisien.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <a 
                href="#calculator"
                className="flex items-center justify-center gap-2 bg-brand-red text-white px-8 py-4 rounded-full font-semibold hover:bg-brand-darkRed transition-all shadow-lg shadow-brand-red/40 hover:-translate-y-1"
              >
                Cek Ongkos Kirim <FiArrowRight />
              </a>
              <a 
                href="#services"
                className="flex items-center justify-center gap-2 bg-white/10 text-white border border-white/20 backdrop-blur-md px-8 py-4 rounded-full font-semibold hover:bg-white/20 transition-all"
              >
                Jelajahi Layanan
              </a>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Decorative Wave at bottom */}
      <div className="absolute bottom-0 left-0 w-full overflow-hidden leading-none z-10">
        <svg viewBox="0 0 1200 120" preserveAspectRatio="none" className="relative block w-full h-[50px] md:h-[100px]">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V120H0V95.8C59.71,118,137.46,130.8,207,117.27,247.46,109.34,286.5,88.74,321.39,56.44Z" className="fill-white"></path>
        </svg>
      </div>
    </section>
  );
};

export default Hero;